/**
 * @fileoverview Agent definition for the a-storyline-extractor-v1 primitive.
 *
 * First step of the split storyline extraction pipeline ("Master Architect").
 * Extracts only the A-Story (main external conflict) with thorough beat
 * coverage (up to 4 per phase).
 *
 * @category import.story.extraction
 * @type primitive
 * @see docs/story-architecture.md
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'a-storyline-extractor-v1',
  kind: 'primitive',
  name: 'A-Storyline Extractor',
  description: 'Extracts the A-Story only with thorough beat coverage (up to 4 per phase). First half of a split extraction pipeline.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: [],
    relatedAgents: ['storyline-extraction-pipeline-v1', 'b-storyline-extractor-v1', 'c-storyline-extractor-v1'],
  },
};
